import { processRawInput } from "./processRawInput";
import ItemPlugin from "./TweetItem/TweetItem";
import userShare from "./userShare";

export default function registerTweetPlugin() {
  return { ItemPlugin, userShare, processRawInput };
}
